
import { TScheduler } from "../types";
import useIsMobile from "../../../../hooks/useIsMobile/useIsMobile";
import MobileView from "./MobileView";
import { useEffect, useState } from "react";
import { default as ListView } from "./ListView";
import { TDailySchedule, TDailyScheduleEntry } from "../types";
import { TDailyScheduleExtensions } from "../typeExtensions/TDailyScheduleExtensions";


const WeeklySchedule: React.FC<{
  days: TDailySchedule[],
  app: TScheduler,
  now?: Date,
  onDayChanged: (day: TDailySchedule) => void
}> = ({ days, app, now, onDayChanged: onChanged }) => {

  const isMobile = useIsMobile();
  const [currentTime, setCurrentTime] = useState(now ?? new Date());

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 5000,);
    return () => clearInterval(interval);
  });

  const handleEventChanged = (dayOfWeek: number, event: TDailyScheduleEntry) => {
    const day = days.find(v => v.weekday === dayOfWeek);
    if (!day) return;
    const newDay = TDailyScheduleExtensions.updateItem(day, event);       
    onChanged(newDay);
  }

  const handleEventDeleted = (dayOfWeek: number, event: TDailyScheduleEntry) => {
    const day = days.find(v => v.weekday === dayOfWeek);
    if (!day) return;
    const newDay = TDailyScheduleExtensions.deleteItem(day,  event);
    onChanged(newDay);
  }

  if (isMobile)
    return (<MobileView app={app} days={days} onEventChanged={handleEventChanged} onEventDeleted={handleEventDeleted} now={currentTime}></MobileView>)

  else
    return (<ListView app={app} days={days} onEventChanged={handleEventChanged} onEventDeleted={handleEventDeleted} now={currentTime}></ListView>);
};


export default WeeklySchedule;


